import { Navigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  const [allowed, setAllowed] = useState(false);
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      if (!user) {
        setCheckingRole(false);
        return;
      }

      try {
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);

        if (snap.exists() && snap.data().role === "admin") {
          setAllowed(true);
        }
      } finally {
        setCheckingRole(false);
      }
    };

    if (!loading) {
      checkRole();
    }
  }, [user, loading]);

  // 🔒 VERY IMPORTANT
  if (loading || checkingRole) {
    return <div className="p-6">Loading...</div>;
  }

  if (!user || !allowed) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
